/**
 * App version — single source of truth for the React side.
 *
 * KEEP IN SYNC with `android/app/build.gradle` (versionName) and the Electron
 * package.json. Bump every release.
 */
export const APP_VERSION = "1.3.2";
